export default __webpack_public_path__ + "images/10c2410a7eebdc350bb37893c345f2d1-music_mobile.webp";